  <smr-calendar
    [currentDate]="calendar.currentDate"
    [stylistID]="stylist.getID()"
    [readOnlyStylistPicker]="readOnlyStylistPicker"
    (onEventSelected)="onEventSelected($event)"
    (onTimeSelected)="onTimeSelected($event)"
    (onStylistSelect)="onStylistSelect($event)"
    (eventsDidUpdate)="onEventsDidUpdate($event)"
    (onEventDragEnd)="onEventDragEndHandler($event)"
    (onRangeChanged)="onRangeChanged($event)"
    style="height: 100%; width: 100%"
  >
  </smr-calendar>
